import Vue from "vue";
import Router from "vue-router";
const _import = require("./_import_" + process.env.NODE_ENV);

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/index",
      name: "index",
      component: _import("index"),
    },
    {
      path: "/forgotPwd",
      name: "forgotPwd",
      component: _import("forgotPwd"),
    },
    {
      path: "/signUp",
      name: "signUp",
      component: _import("signUp"),
    },
    {
      path: "/signIn",
      name: "signIn",
      component: _import("signIn"),
    },
    {
      path: "/layout",
      name: "layout",
      component: _import("layout"),
    },
    {
      path: "/",
      name: "join",
      component: _import("join"),
    },
    // setPwd
    {
      path: "/setPwd",
      name: "setPwd",
      component: _import("setPwd"),
    },
    // activateRes
    {
      path: "/activateRes",
      name: "activateRes",
      component: _import("activateRes"),
    },
    {
      path: "/signSuccess",
      name: "signSuccess",
      component: _import("signSuccess"),
    },
    // invalidLink
    {
      path: "/invalidLink",
      name: "invalidLink",
      component: _import("invalidLink"),
    },
    //
    {
      path: "/errorUrl",
      name: "errorUrl",
      component: _import("errorUrl"),
    },
    // unableLink
    {
      path: "/unableLink",
      name: "unableLink",
      component: _import("unableLink"),
    },
    // myAccount
    {
      path: "/myAccount",
      name: "myAccount",
      component: _import("myAccount"),
    },
    {
      path: "/phone",
      name: "phone",
      component: _import("phone"),
    },
    {
      path: "/race",
      name: "race",
      component: _import("race"),
    },
    {
      path: "/wechat",
      name: "wechat",
      component: _import("wechat"),
    },
    {
      path: "/monthly",
      name: "monthly",
      component: _import("monthly"),
    },
    {
      path: "/pay",
      name: "pay",
      component: _import("pay"),
    },
    {
      path: "/star",
      name: "star",
      component: _import("star"),
    },
    {
      path: "/demo",
      name: "demo",
      component: _import("demo"),
    },
    {
      path: "/bindaccount",
      name: "bindaccount",
      component: _import("bindaccount"),
    },
    {
      path: "/eventChristmas",
      name: "eventChristmas",
      component: _import("eventChristmas"),
    },
    {
      path: "/invite",
      name: "invite",
      component: _import("invite"),
    },
    {
      path: "/oneHourCoding",
      name: "oneHourCoding",
      component: _import("ohcIndex"),
    },
    {
      path: "/oneHourGenerateCert",
      name: "oneHourGenerateCert",
      component: _import("ohcGenerateCert"),
    },
    {
      path: "/oneHourGetCert",
      name: "oneHourGetCert",
      component: _import("ohcGetCert"),
    },
    {
      path: "*",
      redirect: "/",
    },
    // 获取israel的什么参数 ， 后端的要求
    {
      path: "/getMessage",
      component: () => import("../components/forIsrael/index.vue"),
    },
  ],
  mode: "history", //后端支持可开
  scrollBehavior: () => ({
    y: 0,
  }),
});



// WEBPACK FOOTER //
// ./src/router/index.js